import type React from "react";
import { useState } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import useEcommerceReportMutation from "app/pages/sales-intelligence/modules/company-analysis/queries/useEcommerceReportMutation";
import { translate } from "app/filters/i18nFilter";

import { StyledReportEcommerceWrapper } from "./styles";

type Props = {
    isAlreadyReported: boolean;
    domain: string;
};

export const ReportEcommerce: React.FC<Props> = ({ isAlreadyReported, domain }) => {
    const [isReported, setIsReported] = useState(isAlreadyReported);

    const { mutate } = useEcommerceReportMutation();

    const handleReport = () => {
        mutate(domain);
        setIsReported(true);
    };

    return (
        <StyledReportEcommerceWrapper>
            {isReported ? (
                <>
                    <Text
                        fontVariant="input2"
                        color={colorsPalettes.carbon[500]}
                        padding="10px 0"
                    >
                        {translate("si.company-analysis.company-data.card.ecommerce.reported.text")}
                    </Text>
                    <Text
                        fontVariant="input2"
                        color={colorsPalettes.carbon[300]}
                        padding="10px 0"
                    >
                        {translate("si.company-analysis.company-data.card.ecommerce.reported.text.second")}
                    </Text>
                </>
            ) : (
                <>
                    <Text
                        fontVariant="input2"
                        color={colorsPalettes.carbon[500]}
                    >
                        {translate("si.company-analysis.company-data.card.ecommerce.text")}
                    </Text>
                    <Text
                        fontVariant="input2"
                        color={colorsPalettes.carbon[300]}
                    >
                        {translate("si.company-analysis.company-data.card.ecommerce.text.second")}
                    </Text>
                    <Button
                        type="flat"
                        onClick={handleReport}
                    >
                        {translate("si.company-analysis.company-data.card.ecommerce.button")}
                    </Button>
                </>
            )}
        </StyledReportEcommerceWrapper>
    );
};
